import { useTranslation } from 'react-i18next';

import { Wrapper } from '../../../../shared/ModalComponents';
import TextInput from '../../../../shared/FormStyles/TextInput.jsx';

export const MomentsBanner = ({ header, welcomeMessage, handleChange }) => {
  const { t } = useTranslation('boardSetup');

  return (
    <Wrapper>
      <TextInput
        label={t('moments.headerLabel')}
        charactersLimitVariant="small1"
        name="momentsHeader"
        value={header}
        onChange={handleChange}
      />
      <br />
      <TextInput
        label={t('moments.msgLabel')}
        charactersLimitVariant="small1"
        as="textarea"
        charactersLimit={400}
        name="momentsMessage"
        value={welcomeMessage || ''}
        onChange={handleChange}
      />
    </Wrapper>
  );
};
